import { BASE } from "./api/client";

let refreshPromise: Promise<boolean> | null = null;

/** POST /auth/refresh with deduplicated in-flight requests. */
export async function tryRefreshSession(): Promise<boolean> {
  if (!refreshPromise) {
    refreshPromise = fetch(`${BASE}/auth/refresh`, {
      method: "POST",
      credentials: "include",
    })
      .then((r) => r.ok)
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}
